import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState, mapActions } from "vuex";
export default {
  computed: _objectSpread({}, mapState("d2admin/user", ["info"])),
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/account", ["logout"])), {}, {
    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    }
  })
};